import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button,IconButton, Typography } from "@mui/material";
import dayjs from "dayjs";
import { UserRoles } from "src/constants/user";
import { elementStyle, priceNormalizer } from 'src/utils/helpers';
import { PriceActionTypes } from 'src/utils/helpers/helpers.types';

import { CloseIcon, PenMenuIcon } from "../../Icons";
import {
  setBookingsDialogParams,
  showBookingsDialog,
} from "../../store/reducers/dialogSlice";
import { closeDrawer } from "../../store/reducers/drawerSlice";
import { resetSelectedRow } from "../../store/reducers/tableSlice";

export const RightBookingsDrawer = () => {
  const dispatch = useDispatch();

  const { user } = useSelector((state: any) => state.auth);
  // @ts-ignore
  const role = UserRoles[user?.role];

  const { isShown } = useSelector((state: any) => state.drawer);
  const { selectedRow: rowData } = useSelector((state: any) => state.table);

  const price = priceNormalizer(rowData?.price, PriceActionTypes.Showing)?.toFixed(2);

  const handleClose = () => {
    dispatch(resetSelectedRow());
    dispatch(closeDrawer());
  };

  const getBasicEditParams = () => {
    return {
      step: 0,
      maxAvailableStep: 0,
      isEdit: true,
      data: rowData,
    };
  };

  const handleEditAllButton = () => {
    handleClose();
    setTimeout(() => {
      dispatch(setBookingsDialogParams(getBasicEditParams()));
      dispatch(showBookingsDialog());
    }, 100);
  };

  const handleEditInfoButton = () => {
    handleClose();
    dispatch(setBookingsDialogParams(getBasicEditParams()));
    dispatch(showBookingsDialog());
  };

  const handleEditStaffTimingButton = () => {
    handleClose();
    dispatch(
      setBookingsDialogParams({
        ...getBasicEditParams(),
        step: 1,
      })
    );
    dispatch(showBookingsDialog());
  };

  const handleEditPaymentMethodButton = () => {
    handleClose();
    dispatch(
      setBookingsDialogParams({
        ...getBasicEditParams(),
        step: 2,
      })
    );
    dispatch(showBookingsDialog());
  };

  const getStatus = (rowData: any) => {
    const withOutBackgroundStyles = "Not paid";

    const showStatus = () => {
      if (rowData?.status === "approved" && !rowData?.payed) {
        return (
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Typography
              sx={{
                backgroundColor: "#E1FFE4",
                color: "#23A26D",
                padding: "2px 8px",
                borderRadius: "6px",
                "&:nth-of-type(2n)": {
                  marginLeft: "4px",
                },
              }}
            >
              {rowData?.status}
            </Typography>
            <Typography
              sx={{
                color: `#1F6AD4`,
                padding: "0 8px",
                backgroundColor: `white`,
                border: `1px solid #1F6AD4`,
                borderRadius: "6px",
                "&:nth-of-type(2n)": {
                  marginLeft: "4px",
                },
              }}
            >
              {withOutBackgroundStyles}
            </Typography>
          </Box>
        );
      }
      if (rowData?.status === "approved" && rowData?.payed) {
        return (
          <Box>
            <Typography
              sx={{
                backgroundColor: "#E1FFE4",
                color: "#23A26D",
                padding: "2px 8px",
                borderRadius: "6px",
                "&:nth-of-type(2n)": {
                  marginLeft: "4px",
                },
              }}
            >
              {rowData?.status}
            </Typography>
            <Typography
              sx={{
                color: `#1F6AD4`,
                padding: "0 8px",
                backgroundColor: `#E3EFFF`,
                border: `1px solid #1F6AD4`,
                borderRadius: "6px",
                "&:nth-of-type(2n)": {
                  marginLeft: "4px",
                },
              }}
            >
              Paid
            </Typography>
          </Box>
        );
      }
      if (rowData?.status === "Cancelled by client") {
        return (
          <Box sx={{
            display: 'flex'
          }}>
            <Typography
              sx={{
                backgroundColor: "#FFEEDF",
                color: "#E46D00",
                padding: "2px 8px",
                borderRadius: "6px",
                "&:nth-of-type(2n)": {
                  marginLeft: "4px",
                },
              }}
            >
            Cancelled by client
            </Typography>
          </Box>
        );
      }
      if (rowData?.status === "removed_by_admin") {
        return (
          <Box sx={{
            display: 'flex'
          }}>
            <Typography
              sx={{
                backgroundColor: "#FFE6E8",
                color: "#D62F39",
                padding: "2px 8px",
                borderRadius: "6px",
                "&:nth-of-type(2n)": {
                  marginLeft: "4px",
                },
              }}
            >
            Deleted by admin
            </Typography>
          </Box>
        );
      } else {
        return (
          <Box sx={{
            display: 'flex'
          }}>
            <Typography
              sx={{
                backgroundColor: "#F3F3F3",
                color: "#676767",
                padding: "2px 8px",
                borderRadius: "6px",
                "&:nth-of-type(2n)": {
                  marginLeft: "4px",
                },
              }}
            >
            Completed
            </Typography>
          </Box>

        );
      }
    };

    return showStatus();
  };

  return (
    <Box
      sx={{
        position: "fixed",
        width: "424px",
        // height: "auto",
        zIndex: 1000,
        backgroundColor: "#F3F3F3",
        top: 82,
        right: "0px",
        display: isShown ? "block" : "none",
        transition: "right 0.3s",
        boxShadow: isShown
          ? "rgba(0, 0, 0, 0.1) -3px 10px 15px 0px"
          : undefined,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        sx={{
          height: "62px",
          backgroundColor: "white",
          padding: "10px 16px",
          justifyContent: elementStyle({
            role,
            roleType: ["SUPER_ADMIN", "MASTER"],
            firstOption: "unset",
            lastOption: "space-between",
          }),
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            width: "32px",
            height: "32px",
            borderRadius: "6px",
            backgroundColor: "#F3F3F3",
            color: "#676767",
            fontSize: "20px",
          }}
          disableRipple
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              marginLeft: elementStyle({
                role,
                roleType: ["SUPER_ADMIN", "MASTER"],
                firstOption: "96px",
                lastOption: "0",
              }),
            }}
          >
            About booking
          </Typography>
        </Box>
        <Button
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            display: elementStyle({
              role,
              roleType: ["SUPER_ADMIN", "MASTER"],
              firstOption: "none",
              lastOption: "inline-flex",
            }),
          }}
          onClick={handleEditAllButton}
          disableRipple
        >
          Edit all
        </Button>
      </Box>

      <Box
        sx={{
          height: "calc(100vh - 82px - 62px)",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            margin: "16px 16px",
            display: "flex",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flex: 1,
              borderRadius: "6px",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "16px 16px 32px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Studio & service
              </Typography>

              <IconButton
                onClick={handleEditInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                  display: elementStyle({
                    role,
                    roleType: ["SUPER_ADMIN", "MASTER"],
                    firstOption: "none",
                    lastOption: "inline-flex",
                  }),
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  flex: "0 1 50%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    margin: "0 0 5px",
                  }}
                >
                  Service
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {rowData.services?.[0].service?.title}
                </Typography>
              </Box>
              <Box
                sx={{
                  flex: "0 1 50%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    margin: "0 0 5px",
                  }}
                >
                  Status
                </Typography>
                <Box>{rowData?.status && getStatus(rowData)}</Box>
              </Box>
            </Box>

            <Box
              sx={{
                marginTop: "16px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#828282",
                  textTransform: "uppercase",
                  margin: "0 0 5px",
                }}
              >
                Studio
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {rowData?.studio?.title}
              </Typography>
            </Box>

            <Box
              sx={{
                marginTop: "16px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#828282",
                  textTransform: "uppercase",
                  margin: "0 0 5px",
                }}
              >
                Customer
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {`${rowData?.user?.firstName} ${rowData?.user?.lastName}`}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            margin: "16px 16px",
            display: "flex",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flex: 1,
              borderRadius: "6px",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "16px 16px 32px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Staff & timing
              </Typography>

              <IconButton
                onClick={handleEditStaffTimingButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                  display: elementStyle({
                    role,
                    roleType: ["SUPER_ADMIN", "MASTER"],
                    firstOption: "none",
                    lastOption: "inline-flex",
                  }),
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flex: "0 1 60%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    margin: "0 0 5px",
                  }}
                >
                  sTaff
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {`${rowData?.master?.firstName}  ${rowData?.master?.lastName} `}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    margin: "0 0 5px",
                  }}
                >
                  Rank
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "400",
                      textTransform: "capitalize",
                    }}
                  >
                    {rowData?.services?.[0].rank}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                marginTop: "16px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flex: "0 1 60%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    margin: "0 0 5px",
                  }}
                >
                  Date
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {`${dayjs(rowData?.from).format("D")} ${dayjs(
                    rowData?.from
                  ).format("MMM")} ${dayjs(rowData?.from).format("YYYY")} `}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    margin: "0 0 5px",
                  }}
                >
                  Time
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "400",
                    }}
                  >
                    {`${dayjs(rowData?.from).format("h:mm A")}`}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                marginTop: "16px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#828282",
                  textTransform: "uppercase",
                  margin: "0 0 5px",
                }}
              >
                Service duration
              </Typography>
              <Box
                sx={{
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  {`${Math.floor(
                    rowData?.services?.[0].service?.duration / 60
                  )} `}
                  <Typography
                    sx={{
                      marginLeft: "4px",
                    }}
                  >
                    h
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    fontWeight: 600,
                    marginLeft: "12px",
                  }}
                >
                  {`${Math.floor(
                    rowData?.services?.[0].service?.duration -
                      Math.floor(
                        rowData?.services?.[0].service?.duration / 60
                      ) *
                        60
                  )} `}
                  <Typography
                    sx={{
                      marginLeft: "4px",
                    }}
                  >
                    min
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            margin: "16px 16px",
            display: "flex",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flex: 1,
              borderRadius: "6px",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "16px 16px 32px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Price & payment method
              </Typography>

              <IconButton
                onClick={handleEditPaymentMethodButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                  display: elementStyle({
                    role,
                    roleType: ["SUPER_ADMIN", "MASTER"],
                    firstOption: "none",
                    lastOption: "inline-flex",
                  }),
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flex: "0 1 60%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    margin: "0 0 5px",
                  }}
                >
                  Total Price
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  <Typography
                    sx={{
                      marginLeft: "4px",
                    }}
                  >{`${price} €`}</Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    margin: "0 0 5px",
                  }}
                >
                  Payment method
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "400",
                    }}
                  >
                    {`${rowData?.paymentType} payment`}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
